import { ClientType, selectUser, useStoreClient } from "@usher/pe-client-front-end-lib"
import { useEffect } from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { NavLink, Route, Switch, useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom"
import { BaseUploadForm } from "./forms/BaseUploadForm"
import { GetVerificationLink } from "./forms/GetVerificationLink"
import { PersonalVerificationForm } from "./forms/PersonalVerificationForm"
import { WalletVerificationForm } from "./forms/WalletVerificationForm"
import { getLink } from "./getLink"
import { GET_LINKS } from "./links"
import { VerificationText } from "./VerificationText"

export const VerificationForm = () => {
  const { client_type } = useStoreClient(selectUser)
  const intl = useIntl()
  const history = useHistory()
  const { path } = useRouteMatch()
  const pathname = useLocation().pathname
  const { type } = useParams<{ type: string }>()
  const isCorporateAccount = client_type === ClientType.Coroporate
  useEffect(() => {
    if (isCorporateAccount) {
      if (type === "exchange" && pathname.includes("get-link")) history.push(getLink(type, void 0, true))
    } else {
      if (type === "card" && ["set-your-wallet", "proof-of-card", "get-link"].some((path) => pathname.includes(path))) history.push(getLink(type))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname, type, isCorporateAccount])
  const LINKS = GET_LINKS(client_type!, type)
  return (
    <>
      <VerificationText title={intl.formatMessage({ id: "pa_175" })}>
        <FormattedMessage id="pa_176" />
      </VerificationText>
      <div className="additional-form center">
        <div className="box box-light">
          <ul className="nav nav-pills application-form__tutorial flex-column align-items-start">
            {LINKS.map(({ route, intl_id, title }, key) => (
              <li key={key} className="application-form__tutorial-name">
                <NavLink to={getLink(type, route, isCorporateAccount)} exact className="application-form__tutorial-link dark-link">
                  {String(key + 1).padStart(2, "0")}. {intl_id !== "" ? <FormattedMessage id={intl_id} /> : title}
                </NavLink>
              </li>
            ))}
          </ul>
          <div className="tab-content">
            {isCorporateAccount ? (
              <Switch>
                {LINKS.map(({ route }, index) => {
                  let to = path
                  if (index > 0) to += `/${route}`
                  if (route === "get-link") return <Route path={`${path}/get-link`} component={GetVerificationLink} />
                  return (
                    <Route path={to} exact={index === 0} key={index}>
                      <BaseUploadForm type={String(17 + index)} client_type={client_type} />
                    </Route>
                  )
                })}
              </Switch>
            ) : (
              <Switch>
                <Route path={`${path}`} exact component={PersonalVerificationForm} />
                <Route path={`${path}/passport`}>
                  <BaseUploadForm type="1" client_type={client_type} />
                </Route>
                <Route path={`${path}/proof-of-address`}>
                  <BaseUploadForm type="2" client_type={client_type} />
                </Route>
                <Route path={`${path}/proof-of-card`}>
                  <BaseUploadForm type="3" client_type={client_type} />
                </Route>
                <Route path={`${path}/photo-with-passport`}>
                  <BaseUploadForm type="4" client_type={client_type} />
                </Route>
                <Route path={`${path}/set-your-wallet`} component={WalletVerificationForm} />
                <Route path={`${path}/get-link`} component={GetVerificationLink} />
              </Switch>
            )}
          </div>
        </div>
      </div>
    </>
  )
}
